export const ProgressCircleCompletedIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" rx="6" fill="#DBF8E7" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.3029 4.2568C9.58273 3.95146 9.5621 3.47703 9.25677 3.19714C8.95145 2.91725 8.477 2.93787 8.1971 3.24321L4.60145 7.1658L3.28033 5.84468C2.98744 5.5518 2.51257 5.5518 2.21967 5.84468C1.92678 6.13755 1.92678 6.61245 2.21967 6.90533L4.09467 8.78033C4.23932 8.925 4.43675 9.00428 4.64127 8.99985C4.8458 8.99535 5.0396 8.9076 5.1779 8.75678L9.3029 4.2568Z"
      fill="#017C3F"
    />
  </svg>
);
